import styled from '@emotion/styled';
import { device } from '@landsbankinn/ui';
import React from 'react';
import { SliceWrapper } from './SliceWrapper';

interface IProps {
  children: React.ReactNode;
  cards: React.ReactNode;
  isArticle: boolean;
}

const AuthorWrapper = styled(SliceWrapper)`
  & > div {
    flex-flow: column-reverse nowrap;
    flex-direction: column-reverse;
    @media ${device.tablet} {
      flex-flow: inherit;
    }
  }
`;

const CardWrap = styled.div`
  @media ${device.tablet} {
    margin-top: -60px;
  }
  @media ${device.desktop} {
    margin-top: -90px;
  }
`;

export const TextWithAuthors = ({ children, cards, isArticle }: IProps) => {
  return (
    <AuthorWrapper
      left={children}
      right={<CardWrap>{cards}</CardWrap>}
      isArticle={isArticle}
      align="Right"
    />
  );
};
